module.exports = __webpack_public_path__ + "videos/3d-export_jp_hevc.685bbd1.mp4";